import React, { useState, useEffect } from 'react'
import { getWhatsappTempalteListManual, getCommunicationPreiviwTempalteByTemplateId, sendDirectTemplateUsingTempalteidAndType } from '../../AdminActionCreator.component'
import Loader from '../../../../presentationals/Loader/Loader.component'
export default function ({ allDetail }) {
    const [selectedTemplate, setselectedTemplate] = useState("")
    const [loader, setLoader] = useState(false)
    const [templateList, setTemplateList] = useState([])
    const [previewTemplate, setPreviewTemplate] = useState('')
    const [finalMsg, setfinalMsg] = useState('')

    useEffect(() => {
        getWhatsappTempalteListManualFn()
    }, [])

    const getWhatsappTempalteListManualFn = () => {
        setLoader(true)
        getWhatsappTempalteListManual(callback => {
            setLoader(false)
            setTemplateList(callback?.data)
        })
    }

    const msgTempleteClick = (val) => {
        setPreviewTemplate("")
        setselectedTemplate(val)
        getCommunicationPreiviwTempalteByTemplateIdFn(val)
    }

    const getCommunicationPreiviwTempalteByTemplateIdFn = (id) => {
        setLoader(true)
        getCommunicationPreiviwTempalteByTemplateId(id, "WHATSAPP", allDetail?.userId, callback => {
            // console.log("cal",callback)
            setLoader(false)
            setPreviewTemplate(callback?.data)
        })
    }

    const whatsappmsgHandler = () => {
        setLoader(true)
        sendDirectTemplateUsingTempalteidAndType(selectedTemplate, "WHATSAPP", allDetail?.userId, callback => {
            setLoader(false)
            setselectedTemplate("")
            setPreviewTemplate("")
            if (callback == "success") {
                setfinalMsg('Message Sent')
            } else {
                setfinalMsg('Failed To Send Message')
            }
            setTimeout(()=>{
setfinalMsg("")
            },5000)
        })
    }
    return (
        <>

            <div className="details-new container-fluid">
                <div className='sms-box'>
                    <label style={{ fontSize: '10px', fontWeight: '500' }}>Select Template</label>
                    <select

                        style={{ width: '100%', background: '#DBE9FF', color: '#000', outline: 'none' }}
                        name="communicationMsg"
                        value={selectedTemplate}
                        onChange={(e) => msgTempleteClick(e.target.value)}
                        className='form-control'
                    >
                        <option value="">Select a template</option>
                        {
                            templateList?.length > 0 ? templateList?.map((val, id) => {
                                return (
                                    <option value={val?.whatsappId} key={id}>{val?.whatsappSubject}</option>
                                )
                            })
                                : ""}

                    </select>


                    <div className="relative_position" style={{}}>
                        <div className="whatsapp-msg" id="whatsappMsg" style={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0, borderBottom: 'none', paddingBottom: window.innerHeight < 650 ? '200px' : '20px', overflow: 'auto', maxHeight: window.innerHeight < 650 ? '400px' : '600px' }}>
                            {loader == true ?
                                <div className="whatsapp-loader">
                                    <div className="fa fa-spinner fa-spin fa-lg" />
                                </div>
                                : ""}
                            <div style={{ whiteSpace: "pre-line", padding: '10px' }}>{previewTemplate}</div>

                        </div>
                    </div>
                    <div style={{
                        borderRadius: '0px 0px 6px 6px', borderTop: ' 1px solid rgba(0, 0, 0, 0.15)', background: 'var(--light-grey-1, #E9ECF5)', padding: '5px'
                    }}>
                        <div className='row'>

                            <div className='col-sm-12 col-xs-12 text-center'>
                                <button className='btn btn-primary' disabled={previewTemplate == "" ? true : false} onClick={e => whatsappmsgHandler(e, 'click')} style={{ margin: '15px 0' }}>
                                    Send
                                    <span className="fa fa-paper-plane" />
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
                <p className="text-center height-20px margin-0 red-text">{finalMsg}</p>

            </div>
        </>
    )
}
